export class ContactLoginDTO {
    public email: string
    public password: string
    public cgos_agent_id?: string
    constructor(email: string, password: string, cgos_agent_id?: string) {
        this.email = email
        this.password = password
        this.cgos_agent_id = cgos_agent_id
    }
}
